// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__AZYIT","gaps":"grid_gaps__7WNXQ"};